import { Box, HStack, Text } from "@chakra-ui/react";
import React from "react";
import VoteButtons from "./vote-buttons";

const Post = ({ post }) => {
  return (
    <HStack key={post.id} w="100%" alignItems="flex-start">
      <Box bg="gray.100" p={4} rounded="md" w="100%">
        <Text>{post.text}</Text>
      </Box>
      <VoteButtons post={post} />
    </HStack>
  );
};

export default Post;
